import { render, staticRenderFns } from "./rateDiscountSettings.vue?vue&type=template&id=58c326b7&scoped=true&"
import script from "./rateDiscountSettings.vue?vue&type=script&lang=js&"
export * from "./rateDiscountSettings.vue?vue&type=script&lang=js&"
import style0 from "./rateDiscountSettings.vue?vue&type=style&index=0&id=58c326b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c326b7",
  null
  
)

export default component.exports